import PropTypes from 'prop-types';
import React from 'react';
import { JsonView } from './WildSky/JsonView';
import { Pagination } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

function getStateFromHash() {
    const text = window.location.hash;
    if (!text) {
        return {};
    }
    return JSON.parse(decodeURIComponent(text.substring(1)));
}

function setStateToHash(value) {
    window.location.hash = encodeURIComponent(JSON.stringify(value));
}

function formatError(error) {
    if (typeof error === 'object') {
        return <pre style={{ color: 'red' }}>{JSON.stringify(error, null, 4)}</pre>;
    } else {
        return <div style={{ color: 'red' }}>{error}</div>;
    }
}

class JsonObjectInput extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            text: props.initialValue,
            error: null,
        };
    }

    handleTextField = e => {
        try {
            const json = eval(`(${e.target.value})`);
            if (typeof json !== 'object') {
                this.setState({ text: e.target.value, error: 'Expecting an object instead of ' + (typeof query) + ': ' + e.target.value });
                this.props.onChange(null);
                return;
            }
            this.setState({ text: e.target.value, error: null });
            this.props.onChange(json);
        } catch (err) {
            this.setState({ text: e.target.value, error: err.message });
            this.props.onChange(null);
        }
    }

    render() {
        return (
            <div>
                {this.state.error && formatError(this.state.error)}
                <textarea rows={10} cols={100} value={this.state.text} onChange={this.handleTextField} />
            </div>
        );
    }
}

JsonObjectInput.propTypes = {
    initialValue: PropTypes.string,
    onChange: PropTypes.func,
};

class AggregateLogs extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            query: getStateFromHash().query || {},
            update: getStateFromHash().update || {},
            add: getStateFromHash().add || {},
            queryResult: null,
            updateResult: null,
            runningQuery: false,
            runningUpdate: false,
            queryError: null,
            updateError: null,
            queryResultQuery: null,
            mode: 1,
        };
    }

    componentDidUpdate() {
        const data = getStateFromHash();
        data.query = this.state.query;
        data.update = this.state.update;
        data.add = this.state.add;
        setStateToHash(data);
    }

    selectMode = m => () => {
        this.setState({ mode: m });
    }

    onQuery = async () => {
        const query = this.state.query;
        this.setState({ runningQuery: true, queryResult: null, queryError: null });
        try {
            const response = await fetch(`${this.props.queryUrl}/${this.props.collection}`, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ query }),
            });
            const result = await response.json();
            if (result.error) {
                this.setState({ runningQuery: false, queryError: result.error });
            } else {
                this.setState({ runningQuery: false, queryResult: result.results, queryResultQuery: query });
            }
        } catch (err) {
            this.setState({ runningQuery: false, queryError: err.message });
        }
    }

    onUpdate = async () => {
        this.setState({ runningUpdate: true, updateResult: null, updateError: null });
        try {
            const response = await fetch(`${this.props.updateUrl}/${this.props.collection}`, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    query: this.state.query,
                    update: this.state.update,
                }),
            });
            const result = await response.json();
            if (result.error) {
                this.setState({ runningUpdate: false, updateError: result.error });
            } else {
                this.setState({ runningUpdate: false, updateResult: result.result });
            }
        } catch (err) {
            this.setState({ runningUpdate: false, updateError: err.message });
        }
    }

    onAdd = async () => {
        this.setState({ runningUpdate: true, updateResult: null, updateError: null });
        try {
            const response = await fetch(
                `${this.props.addUrl}/${this.props.collection}`,
                {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        add: this.state.add,
                    }),
                }
            );
            if (!response.ok) {
                this.setState({runningUpdate: false, updateError: response.statusText});
                return;
            }
            const result = await response.json();
            if (result.error) {
                this.setState({ runningUpdate: false, updateError: result.error });
            } else {
                this.setState({ runningUpdate: false, updateResult: result.result });
            }
        } catch (err) {
            this.setState({ runningUpdate: false, updateError: err.message });
        }
    };

    onChange = (name) => (value) => {
        this.setState({ [name]: value });
    };

    render() {
        // console.log(this.state.data);
        return (
            <div>
                <div style={{ display: 'flex' }}>
                    <div>
                        <JsonObjectInput initialValue={JSON.stringify(this.state.query, null, 4)} onChange={this.onChange('query')} />
                        {this.state.queryError && formatError(this.state.queryError)}
                        <Button onClick={this.onQuery} disabled={!this.state.query}>Search</Button>
                    </div>
                    {!this.props.addUrl && (
                        <div>
                            <Button
                                onClick={this.onUpdate}
                                disabled={
                                    !this.state.update ||
                                    !this.state.queryResult ||
                                    this.state.queryResultQuery !==
                                    this.state.query
                                }
                            >
                                Update
                            </Button>
                            <JsonObjectInput
                                initialValue={JSON.stringify(
                                    this.state.update,
                                    null,
                                    4
                                )}
                                onChange={this.onChange('update')}
                            />
                        </div>
                    )}
                    {this.props.addUrl && (
                        <div>
                            <Pagination>
                                <Pagination.Item
                                    key={1}
                                    active={this.state.mode === 1}
                                    onClick={this.selectMode(1)}
                                >
                                    Update
                                </Pagination.Item>
                                <Pagination.Item
                                    key={2}
                                    active={this.state.mode === 2}
                                    onClick={this.selectMode(2)}
                                >
                                    Add
                                </Pagination.Item>
                            </Pagination>
                            {
                                this.state.mode === 1 &&
                                <div>
                                    <JsonObjectInput
                                        initialValue={JSON.stringify(
                                            this.state.update,
                                            null,
                                            4
                                        )}
                                        onChange={this.onChange('update')}
                                    />
                                    <Button
                                        onClick={this.onUpdate}
                                        disabled={
                                            !this.state.update ||
                                            !this.state.queryResult ||
                                            this.state.queryResultQuery !==
                                            this.state.query
                                        }
                                    >
                                        Go
                                    </Button>
                                </div>
                            }
                            {
                                this.state.mode === 2 &&
                                <div>
                                    <JsonObjectInput
                                        initialValue={JSON.stringify(
                                            this.state.add,
                                            null,
                                            4
                                        )}
                                        onChange={this.onChange('add')}
                                    />
                                    <Button
                                        onClick={this.onAdd}
                                        disabled={
                                            !this.state.add ||
                                            !this.state.queryResult ||
                                            this.state.queryResultQuery !==
                                            this.state.query
                                        }
                                    >
                                        Go
                                    </Button>
                                </div>
                            }
                        </div>
                    )}
                    <div>
                        {this.state.updateError && formatError(this.state.updateError)}
                        {
                            this.state.runningUpdate && <div>Running update ...</div>
                        }
                        {
                            !this.state.runningUpdate &&
                            <pre>
                                {JSON.stringify(this.state.updateResult, null, 4)}
                            </pre>
                        }
                    </div>
                </div>
                {
                    this.state.runningQuery && <div>Running query ...</div>
                }
                {
                    !this.state.runningQuery &&
                    <JsonView value={this.state.queryResult} />
                }
            </div>
        );
    }
}

AggregateLogs.propTypes = {
    queryUrl: PropTypes.string,
    updateUrl: PropTypes.string,
    addUrl: PropTypes.string,
    collection: PropTypes.string,
};

class CollectionList extends React.PureComponent {
    state = {
        results: null,
    };

    componentDidMount() {
        this.fetchCollectionList();
    }

    async fetchCollectionList() {
        const response = await fetch(this.props.url);
        const result = await response.json();
        this.setState({ results: result.results.sort() });
    }

    onClick = (result) => () => {
        this.props.onSelect(result);
    };

    render() {
        if (!this.state.results) {
            return 'Loading...';
        }
        return (
            <ul>
                {
                    this.state.results.map(result => (
                        <li key={result} onClick={this.onClick(result)} style={{ backgroundColor: result === this.props.selected ? 'skyblue' : null }}>{result}</li>
                    ))
                }
            </ul>
        );
    }
}

CollectionList.propTypes = {
    selected: PropTypes.string,
    onSelect: PropTypes.func,
    url: PropTypes.string,
};

class Aggregate extends React.PureComponent {
    state = {
        collection: getStateFromHash().collection,
    };

    componentDidUpdate() {
        const data = getStateFromHash();
        data.collection = this.state.collection;
        setStateToHash(data);
    }

    onSelect = (result) => {
        this.setState({ collection: result });
    };

    render() {
        return (
            <div style={{ display: 'flex', height: '100%' }}>
                <div style={{ width: '200px', flexShrink: 0 }}>
                    <CollectionList url={this.props.collectionsUrl} selected={this.state.collection} onSelect={this.onSelect} />
                </div>
                <div style={{ flexGrow: 1, position: 'relative' }}>
                    <div style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, overflow: 'auto' }}>
                        {
                            this.state.collection &&
                            <AggregateLogs key={this.state.collection} updateUrl={this.props.updateUrl} queryUrl={this.props.queryUrl} addUrl={this.props.addUrl} collection={this.state.collection} />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

Aggregate.propTypes = {
    collectionsUrl: PropTypes.string,
    updateUrl: PropTypes.string,
    queryUrl: PropTypes.string,
    addUrl: PropTypes.string,
};

export function Update() {
    return (
        <Aggregate
            collectionsUrl="/api/data/collections"
            updateUrl="/api/data/update"
            queryUrl="/api/data/search"
            addUrl="/api/data/add"
        />
    );
}

export function UpdateSupport() {
    return (
        <Aggregate
            collectionsUrl="/api/data/support_collections"
            updateUrl="/api/data/update_support"
            queryUrl="/api/data/search_support"
            addUrl="/api/data/add_support"
        />
    );
}
